import React, { memo } from 'react';
import { sample } from 'lodash';
import { Flex } from 'core/components';
import { ShimmerThinkingIndicator } from '../../journeys/PromptResponse';

const phrases = [
  'Generating response...',
  'Composing reply....',
  'Processing request...',
  'Crafting a response...',
  'Working on it...'
];

const thinker = (text) => (
  <Flex alignItems="center" gap="6px">
    <ShimmerThinkingIndicator>{text || sample(phrases)}</ShimmerThinkingIndicator>
  </Flex>
);

// Memoized thinker component to prevent unnecessary re-renders
const ThinkingIndicator = memo(({ text }) => thinker(text));

ThinkingIndicator.displayName = 'ThinkingIndicator';

export default ThinkingIndicator;
